import { getFormattedPrice, getArrayElementByKey } from '../../utils';
import { QuoteService } from '../services/QuotationService';
/**
 * Quotation Store
 */
class QuotationStore {
    constructor() {
        this.testData = {
            preliminaryInfo: {
                quoteType: 'studStockAnimal',
                animalType: 'bull',
                state: 'AU_NSW',
                email: 's@s.com',
                purchasePrice: '20000',
                selectedPremiumType: {
                    animalType: 'bull',
                    basePrice: '$1,800.00',
                    gst: '$180.00',
                    index: 1,
                    month: '12 Months',
                    policyTerm: 12,
                    percentage: 9,
                    premium: '$1,980.00',
                    purchasePrice: '20000',
                    stampDuty: '$0.00',
                    starIndex: 2,
                },
                selectedFIS: null,
                hasIndividualOver50k: null
            },
            entities: [
                {
                    id: 0,
                    abnAcn: '26008672179',
                    email: 's@s.com',
                    address: {
                        addressLine1: '321 Kent Street',
                        city: 'SYDNEY',
                        state: 'NSW',
                        postalCode: '2000',
                        country: 'AU',
                        addressType: 'Physical',
                        displayName: '321 Kent Street, SYDNEY NSW 2000'
                    },
                    companyName: null,
                    entityType: 'Individual',
                    firstName: 'Salman',
                    isGSTRegistered: '',
                    lastName: 'Ahmed',
                    phoneNumber: '0431724000',
                    role: 'Account Holder',
                    dateOfBirth: '1990-01-01',
                },
                {
                    id: 1,
                    abnAcn: '008672179',
                    email: 's2@s.com',
                    address: {
                        addressLine1: 'Level 1, 321 Kent Street',
                        city: 'SYDNEY',
                        state: 'NSW',
                        postalCode: '2000',
                        country: 'AU',
                        addressType: 'Physical',
                        displayName: 'Level 1, 321 Kent Street, SYDNEY NSW 2000'
                    },
                    companyName: 'Tenzing Ltd.',
                    entityType: 'Company',
                    firstName: undefined,
                    isGSTRegistered: 'YES',
                    lastName: undefined,
                    phoneNumber: '0431700000',
                    role: 'Additional Insured',
                    dateOfBirth: '1995-01-01',
                }
            ],
            animals: [
                {
                    animalDOB: '2021-01-20',
                    animalName: 'Animal 1',
                    animalType: 'bull',
                    animalSubType: 'belmont_red',
                    lotNumber: '11',
                    policyTerm: '12',
                    purchasePrice: '20000',
                    rfid: '112233',
                    saleDate: '2021-01-10',
                    saleName: 'Sale 1',
                    saleType: 'auction',
                    starCover: '2',
                    isGSTRegistered: '',
                },
                {
                    animalDOB: '2021-01-20',
                    animalName: 'Animal 2',
                    animalType: 'bull',
                    animalSubType: 'angus',
                    lotNumber: '11',
                    policyTerm: '12',
                    purchasePrice: '20000',
                    rfid: '112233',
                    saleDate: '2021-01-10',
                    saleName: 'Sale 1',
                    saleType: 'auction',
                    starCover: '3',
                    isGSTRegistered: '',
                },
            ],
            documents: [],
            quoteId: null,
            sessionUUID: null,
            rateCards: [],
        };
        this.blankData = {
            preliminaryInfo: {
                quoteType: 'studStockAnimal',
                email: null,
                selectedPremiumType: {},
                selectedFIS: null,
                hasIndividualOver50k: null,
                farmVehicle: null,
            },
            // NEW: central sale state
            sale: {
                saleDate: '',     // YYYY-MM-DD
                saleName: '',
                saleType: 'auction',     // 'auction' | 'private' | 'online' (whatever your UI uses)
            },
            entities: [],
            animals: [],
            documents: [],
            quoteId: null,
            sessionUUID: null,
            rateCards: [],
        };
        this.quotation = this.blankData; //this.testData
        this.quotedPremiumTypes = {};
        this.guidewireQuote = {};

        this.states = [
            { id: 'AU_ACT', name: 'A.C.T.', rate: 0 },
            { id: 'AU_NSW', name: 'New South Wales', rate: 0 },
            { id: 'AU_NT', name: 'Northern Territory', rate: 0 },
            { id: 'AU_QLD', name: 'Queensland', rate: 0.09 },
            { id: 'AU_SA', name: 'South Australia', rate: 0.11 },
            { id: 'AU_TAS', name: 'Tasmania', rate: 0.1 },
            { id: 'AU_VIC', name: 'Victoria', rate: 0 },
            { id: 'AU_WA', name: 'Western Australia', rate: 0.1 },
        ];
        this.animalSubTypes = {
            bull: [
                { id: 'beef_breed', name: 'Beef Breed' },
                { id: 'angus', name: 'Angus' },
                { id: 'angus_x', name: 'Angus X' },
                { id: 'belmont_red', name: 'Belmont Red' },
                { id: 'belted_galloway', name: 'Belted Galloway' },
                { id: 'blonde_dd_aquitaine', name: 'Blonde dd\'Aquitaine' },
                { id: 'braford', name: 'Braford' },
                { id: 'brahman', name: 'Brahman' },
                { id: 'brangus', name: 'Brangus' },
                { id: 'charbray', name: 'Charbray' },
                { id: 'charolais', name: 'Charolais' },
                { id: 'droughmaster', name: 'Droughmaster' },
                { id: 'greyman', name: 'Greyman' },
                { id: 'hereford', name: 'Hereford (including poll)' },
                { id: 'lowline', name: 'Lowline' },
                { id: 'murray_grey', name: 'Murray Grey' },
                { id: 'red_angus', name: 'Red Angus' },
                { id: 'red_poll', name: 'Red Poll' },
                { id: 'santa_gertrudis', name: 'Santa Gertrudis' },
                { id: 'shorthorn', name: 'Shorthorn (including poll)' },
                { id: 'simmental', name: 'Simmental' },
                { id: 'other', name: 'Other' },
            ],
            ram: [
                { id: 'merino', name: 'Merino' },
                { id: 'poll_dorset', name: 'Poll Dorset' },
                { id: 'border_leicester', name: 'Border Leicester' },
                { id: 'suffolk', name: 'Suffolk' },
                { id: 'dohne', name: 'Dohne' },
                { id: 'dorper', name: 'Dorper' },
                { id: 'other', name: 'Other' },
            ],
        };
    }

    /**
     * Set step 1 in store
     * @param animalType
     * @param purchasePrice
     * @param email
     * @param state
     * @param selectedFIS
     * @param hasIndividualOver50k
     */
    setStep1({ quoteType, animalType, purchasePrice, email, state, selectedFIS, hasIndividualOver50k, wasAssistedByAchmea, farmVehicle }) {
        const currentInfo = this.quotation.preliminaryInfo;
        const resolvedQuoteType = quoteType || currentInfo.quoteType || 'studStockAnimal';
        const hasChanged =
            currentInfo.animalType !== animalType ||
            currentInfo.purchasePrice !== purchasePrice ||
            currentInfo.state !== state ||
            currentInfo.quoteType !== resolvedQuoteType;
        this.quotation.preliminaryInfo = {
            quoteType: resolvedQuoteType,
            animalType: animalType,
            state: state,
            email: email,
            purchasePrice: purchasePrice,
            selectedFIS: selectedFIS,
            hasIndividualOver50k: hasIndividualOver50k,
            selectedPremiumType: hasChanged ? {} : currentInfo.selectedPremiumType,
            wasAssistedByAchmea: wasAssistedByAchmea,
            farmVehicle: farmVehicle || currentInfo.farmVehicle || null,
        };

        // Reset rateCards if data has changed
        if (hasChanged) {
            this.quotation.rateCards = [];
        }
    }

    /**
     * This function returns all premium types
     * @return array
     */
    async getQuotedPremiumTypes(force = false) {
        const { animalType, purchasePrice, state } = this.quotation.preliminaryInfo;

        // Return empty array if no purchase price
        if (!purchasePrice) {
            return [];
        }

        // Check if rateCards already exist (skip when force is true)
        if (!force && this.quotation.rateCards && this.quotation.rateCards.length > 0) {
            return this._transformRateCardsToPremiumTypes(this.quotation.rateCards);
        }

        try {
            // Fetch rate cards from API
            const requestPayload = {
                state: state,
                ssAnimals: this.quotation.animals
            };

            const rateCards = await QuoteService('getRateCards', requestPayload);

            // Store the rate cards
            this.quotation.rateCards = rateCards;

            // Transform and return the data
            return this._transformRateCardsToPremiumTypes(rateCards);

        } catch (error) {
            console.error('Error fetching rate cards:', error);
            return [];
        }
    }

    /**
     * Transform API rate cards to the expected premium types format
     * @param rateCards - Array of rate card objects from API
     * @return array - Transformed data in the expected format
     */
    _transformRateCardsToPremiumTypes(rateCards) {
        const transformedData = [[], [], []]; // 3 arrays for 3, 6, 12 months
        rateCards.forEach(rateCard => {
            let monthIndex = 0;
            let monthLabel = '';
            let policyTerm = 0;
            // Map term duration to our format
            switch (rateCard.termDuration) {
                case 'Inx_quaterly':
                    monthIndex = 0;
                    monthLabel = '3 Months';
                    policyTerm = 3;
                    break;
                case 'HalfYear':
                    monthIndex = 1;
                    monthLabel = '6 Months';
                    policyTerm = 6;
                    break;
                case 'Annual':
                    monthIndex = 2;
                    monthLabel = '12 Months';
                    policyTerm = 12;
                    break;
                default:
                    return; // Skip unknown term durations
            }

            // Map star level to index
            let starIndex = 0;
            switch (rateCard.starLevel) {
                case 'one_star':
                    starIndex = 0;
                    break;
                case 'two_star':
                    starIndex = 1;
                    break;
                case 'three_star':
                    starIndex = 2;
                    break;
                default:
                    return; // Skip unknown star levels
            }

            // Calculate base price (total premium minus taxes)
            const basePrice = rateCard.totalPremium - rateCard.gst - rateCard.stampDuty;

            // Create premium type object
            const premiumType = {
                state: this.quotation.preliminaryInfo.state,
                premium: getFormattedPrice(rateCard.totalPremium),
                month: monthLabel,
                policyTerm: policyTerm,
                percentage: 0, // Not provided by API, set to 0
                basePrice: getFormattedPrice(basePrice),
                gst: getFormattedPrice(rateCard.gst),
                stampDuty: getFormattedPrice(rateCard.stampDuty),
                fsl: getFormattedPrice(rateCard.fsl),
                purchasePrice: this.quotation.preliminaryInfo.purchasePrice,
                animalType: this.quotation.preliminaryInfo.animalType,
                starIndex: starIndex + 1, // Convert to 1-based index
                levelOfCover: rateCard.starLevel,
            };
            // Add to the appropriate month array
            transformedData[monthIndex].push(premiumType);
        });
        return transformedData;
    }

    // Also add a tiny helper to stamp sale onto a single animal (optional but handy)
    _applySaleToAnimal(animal) {
        const s = this.quotation.sale || {};
        return {
            ...animal,
            ...(s.saleDate ? { saleDate: s.saleDate } : {}),
            ...(s.saleName ? { saleName: s.saleName } : {}),
            ...(s.saleType ? { saleType: s.saleType } : {}),
        };
    }


    // In QuotationStore
    getSale() {
        return this.quotation.sale || { saleDate: '', saleName: '', saleType: '' };
    }

    setSale(patch) {
        const prev = this.getSale();
        const nextSale = { ...prev, ...patch };
        this.quotation.sale = nextSale;

        // propagate to animals
        if (Array.isArray(this.quotation.animals)) {
            this.quotation.animals = this.quotation.animals.map(a => ({
                ...a,
                ...(patch.saleDate !== undefined ? { saleDate: nextSale.saleDate } : {}),
                ...(patch.saleName !== undefined ? { saleName: nextSale.saleName } : {}),
                ...(patch.saleType !== undefined ? { saleType: nextSale.saleType } : {}),
            }));
        }
        console.log(this.quotation.animals)
    }



    // (optional) when adding one new animal from anywhere, stamp sale immediately
    addAnimal(animal) {
        const stamped = this._applySaleToAnimal(animal);
        this.quotation.animals = [...(this.quotation.animals || []), stamped];
        return stamped;
    }

    /**
     * Set selected premium in store
     * @param premiumType
     */
    setSelectedPremiumType(premiumType) {
        this.quotation.preliminaryInfo.selectedPremiumType = premiumType;

        // Update animals' starCover and policyTerm if there are any animals
        if (this.quotation.animals && this.quotation.animals.length > 0) {
            this.quotation.animals = this.quotation.animals.map(animal => ({
                ...animal,
                starCover: premiumType.starIndex.toString(),
                policyTerm: premiumType.policyTerm.toString()
            }));
        }
    }

    // ---- GST helpers ----
    getGST() {
        return this.quotation.gst || { isGSTRegistered: '' };
    }

    setGST(status /* 'YES' | 'NO' | '' */) {
        this.quotation.gst = { isGSTRegistered: status || '' };
        this._applyGSTToAllAnimals();
    }

    _applyGSTToAllAnimals() {
        const gst = this.getGST().isGSTRegistered;
        this.quotation.animals = (this.quotation.animals || []).map(a => ({
            ...a,
            isGSTRegistered: gst == 'YES' ? true : false, // overwrite to stay consistent
        }));
    }


    /**
     * Get selected premium in store
     */
    getSelectedPremiumType() {
        return this.quotation.preliminaryInfo.selectedPremiumType;
    }

    /**
     * Set entities in the store
     * @param arr
     */
    setEntities = arr => {
        this.quotation.entities = arr;
    }

    /**
     * Get entities from the store
     * @return arr
     */
    getEntities = () => {
        return this.quotation.entities;
    }

    /**
     * Set animals in the store
     * @param arr
     */
    setAnimals = arr => {
        this.quotation.animals = arr;
    }

    /**
     * Get animals from the store
     * @return arr
     */
    getAnimals = () => {
        return this.quotation.animals;
    }

    /**
     * Set documents in the store
     * @param arr
     */
    setDocuments = arr => {
        this.quotation.documents = arr;
    }

    /**
     * Get documents from the store
     * @return arr
     */
    getDocuments = () => {
        return this.quotation.documents;
    }

    /**
     * Get Session UUID from the store
     * @return arr
     */
    getSessionUUID = () => {
        return this.quotation.sessionUUID;
    }

    /**
     * Set Session UUID in the store
     */
    setSessionUUID = ({ sessionUUID }) => {
        this.quotation.sessionUUID = sessionUUID;
    }

    /**
     * Get quotation id from the store
     * @return arr
     */
    getQuoteId = () => {
        return this.quotation.quoteId;
    };

    /**
     * Set quotation id in the store
     */
    setQuoteId = ({ quoteId }) => {
        this.quotation.quoteId = quoteId;
    }

    /**
     * Set quotation id and Session UUID in the store
     */
    setQuoteSessionId = ({ quoteId, sessionUUID }) => {
        this.quotation.quoteId = quoteId;
        this.quotation.sessionUUID = sessionUUID;
    }

    /**
     * Get states
     * @returns []
     */
    getStates() {
        return this.states;
    }

    /**
     * This function returns animal sub types
     * @param $animalType
     * @returns array
     */
    getAnimalSubTypes($animalType) {
        if ($animalType === 'bull')
            return this.animalSubTypes.bull;

        if ($animalType === 'ram')
            return this.animalSubTypes.ram;

        return [];
    }

    /**
     * Get quotation
     * @returns {{}}
     */
    getQuotation() {
        return this.quotation;
    }

    /**
     * Get guidewire quotation
     * @returns {{}}
     */
    getGuidewireQuote() {
        return this.guidewireQuote;
    }

    /**
     * Set guidewire quotation
     * @param quote
     */
    setGuidewireQuote(quote) {
        this.guidewireQuote = quote;
    }

    /**
     * Set guidewire policy ID and quote status to bound
     * @param policyId
     */
    setGuidewirePolicyID(policyId) {
        this.guidewireQuote = {
            ...this.guidewireQuote,
            GWPolicyID: policyId,
            quoteStatus: 'Bound'
        };
    }

    /**
     * Reset session
     */
    resetQuotation() {
        this.quotation = {
            preliminaryInfo: {
                quoteType: 'studStockAnimal',
                email: null,
                selectedPremiumType: {},
                selectedFIS: null,
                farmVehicle: null,
            },
            entities: [],
            animals: [],
            documents: [],
            quoteId: null,
            sessionUUID: null,
            rateCards: [],
        };
        this.guidewireQuote = {};
        console.log('reset session data', this.quotation);
    }
}

export default QuotationStore;
